import React from "react";
import themePropTypes from "../theme-prop-types";

const CreditCardLogo = ({ type }) => (
  <div
    className={`credit-card-logo-web-sdk card-${type}`}
    data-testid={`card-${type}`}
  />
);

CreditCardLogo.propTypes = themePropTypes.creditCardLogo;

export default CreditCardLogo;
